import React, { Component } from "react";
import { AuthUserContext } from "../Session";
import {
  Container,
  Grid,
  TextField,
  FormControl,
  Fade,
  FormHelperText,
  LinearProgress,
} from "@material-ui/core";
import CustomButton from "../Button";
import Helpers from "../Helpers";
import AccountProfileFunction from "./AccountProfileFunction";
import ReusableModal from "./ReusableModal";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/route";

import PhoneInput from "react-phone-input-2";

class EditAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: props.edit_account.firstName,
      lastName: props.edit_account.lastName,
      email: props.edit_account.email,
      mobileNumber: props.edit_account.mobileNumber,
      tin: props.edit_account.tin,
      tinError: "",
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      mobileNumberError: "",
      isLoading: false,
      showModal: false,
      modalButton: "",
      modalTitle: "",
      modalContent: "",
    };
    this.helpers = new Helpers();
    this.accountProfileFunction = new AccountProfileFunction();
  }

  onChange = (event) => {
    const me = this;
 const { name, value } = event.target;

this.setState(
  { [name]: value },
  () => {
      const result = this.helpers.validator(this.state, name);
      this.setState({ [result?.name]: result.error });
  }

);


  };


  update = (type) => {
    this.setState({ showModal: false, isLoading: false });
    if (type === "success") {
      // Reload so the pending-approval banner reflects the new state.
      window.location.reload();
    }
  };

  submit = (e) => {
    e.preventDefault();
    const uid = this.context.uid;
    const { email, mobileNumber,tin } = this.state;

    this.setState({ isLoading: true });
    this.accountProfileFunction
      .doUpdateAccount(uid, email, mobileNumber,tin)
      .then((response) => {
        var modalButton = (
          <CustomButton
            type="button"
            text="Okay"
            buttonTheme="success"
            onClick={() => this.update("success")}
          />
        );
        if (response.data.ok) {
          this.setState({
            modalTitle: "Submitted for Approval",
            modalContent:
              "Your account update has been submitted and is pending approval. You'll be notified once it has been reviewed.",
            modalButton: modalButton,
            showModal: true,
          });
        } else {
          this.setState({
            modalButton: modalButton,
            modalTitle: "Warning!",
            modalContent: response.data.message,
            showModal: true,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        var modalButton = (
          <CustomButton
            type="button"
            text="Try Again"
            buttonTheme="danger"
            onClick={() => this.update("error")}
          />
        );
        this.setState({
          modalButton: modalButton,
          modalTitle: "Warning!",
          modalContent: error.message,
          showModal: true,
        });
      });
  };

  static contextType = AuthUserContext;

  render() {
    const {
      firstName,
      lastName,
      email,
      mobileNumber,
      firstNameError,
      lastNameError,
      mobileNumberError,
      emailError,
      showModal,
      modalTitle,
      modalContent,
      modalButton,
      isLoading,
      tin,
      tinError
    } = this.state;
    const isPending = Boolean(this.props.edit_account.accountUpdatePending);
    return (
      <>
        <ReusableModal
          show={showModal}
          title={modalTitle}
          content={modalContent}
          button={modalButton}
        />
        <form onSubmit={this.submit}>
          <Container>
            <h1>Edit Account</h1>
            {isPending && (
              <div
                style={{
                  backgroundColor: "#FFF7E6",
                  border: "1px solid #FFD591",
                  borderRadius: 8,
                  padding: "12px 16px",
                  marginBottom: 16,
                  color: "#874D00",
                }}
              >
                You have an account update awaiting approval. You can submit new
                changes once it has been reviewed.
              </div>
            )}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <label className="dark-label bold">TIN Number</label>
              <TextField
  type="number"
  name="tin"
  value={tin}
  inputProps={{ style: { padding: "12px" } }}
  variant="outlined"
  fullWidth
  required
  placeholder="Enter TIN Number"
  autoComplete="off"
  onChange={this.onChange}
  InputProps={{
    readOnly: Boolean(this.props.edit_account.tin) || isPending,
  }}
/>

               <Fade in={true}>
                  <FormHelperText style={{ color: "red" }}>
                    {tinError}
                  </FormHelperText>
                </Fade>
<i>Note: TIN can be only be updated once</i>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ display:"none"}}>
                <label className="dark-label bold">First Name</label>
                <TextField
                
                  name="firstName"
                  value={firstName}
                  inputProps={{ style: { padding: "12px" } }}
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Your first name..."
                  autoComplete="off"
                  onChange={this.onChange}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Fade in={true}>
                  <FormHelperText style={{ color: "red" }}>
                    {firstNameError}
                  </FormHelperText>
                </Fade>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ display:"none"}}>
                <label className="dark-label bold">Last Name</label>
                <TextField
                  name="lastName"
                  value={lastName}
                  inputProps={{ style: { padding: "12px" } }}
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Your last name..."
                  autoComplete="off"
                  onChange={this.onChange}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Fade in={true}>
                <FormHelperText style={{ color: "red" }}>
                  {lastNameError}
                </FormHelperText>
              </Fade>
            </Grid>
            <br /> <br />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ display:"none"}}>
                <label className="dark-label bold">Email Address</label>
                <TextField
                  type="email"
                  name="email"
                  value={email}
                  inputProps={{ style: { padding: "12px" } }}
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Your email address..."
                  autoComplete="off"
                  onChange={this.onChange}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Fade in={true}>
                  <FormHelperText style={{ color: "red" }}>
                    {emailError}
                  </FormHelperText>
                </Fade>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <label className="dark-label bold">Mobile Number</label>
                <FormControl fullWidth>
                  <PhoneInput
                    country={"ph"}
                    masks={{
                      ph: "(...) ... ....",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    inputStyle={{
                      width: "100%",
                      padding: "12px 0px 12px 50px",
                    }}
                    placeholder="Mobile Number"
                    inputClass="mobile-number-input"
                    value={mobileNumber}
                    countryCodeEditable={false} 
                    disabled={isPending}
                    specialLabel=""
                      onChange={(value, country) => {
              let formattedValue = value;


              if (country.countryCode === "ph"  && (/^(09|630|\+630)/.test(value))) {

                    if (/^09/.test(value)) {
                      formattedValue = value.replace(/^0/, "+63");
                    }
                   
                    else if (/^630/.test(value)) {
                      formattedValue = value.replace(/^630/, "+63");
                    }
                    
                    else if (/^\+630/.test(value)) {
                      formattedValue = value.replace(/^\+630/, "+63");
                    }

                  }

              this.setState((prev)=>({...prev, mobileNumber:formattedValue}));
            }}
                  
                  />
                </FormControl>
                <Fade in={true}>
                  <FormHelperText style={{ color: "red" }}>
                    {mobileNumberError}
                  </FormHelperText>
                </Fade>
              </Grid>
            </Grid>
            <br /> <br />
            {!isLoading ? (
              <CustomButton
              disabled={ tin.length > 12  ||tin.length < 9 || isPending }
                text={isPending ? "Pending Approval" : "Save Changes"}
                type="submit"
                className="float-right"
              />
            ) : (
              <LinearProgress color="primary" />
            )}
            {this.props.edit_account.verified && (
              <div
                style={{
                  clear: "both",
                  paddingTop: 24,
                  marginTop: 8,
                  borderTop: "1px solid #eee",
                }}
              >
                <label className="dark-label bold">Full account review</label>
                <p style={{ color: "#666", margin: "4px 0 12px" }}>
                  Update your full KYC details, IDs, and risk profile. This is
                  separate from the mobile number and TIN fields above.
                </p>
                <Link
                  to={ROUTES.UPDATE_KYC}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#256141",
                    color: "white",
                    padding: "10px 16px",
                    borderRadius: 4,
                    textDecoration: "none",
                  }}
                >
                  Update Account Information
                </Link>
              </div>
            )}
          </Container>
        </form>
      </>
    );
  }
}

export default EditAccount;
